import ChangePasswordModal from "./change-password-modal.component";

export default ChangePasswordModal;
